import ConditionHandler from '../../Dependencies/ConditionHandler';
import DataStore from '../../stores/DataStore'

class RuleHandler {
  /**
   * Modul, welches Regeln für ein Modul verwaltet
   * Eventuell muss dieses Modul noch umgeschrieben werden
   *      (sodass es mehrere Regeln verwaltet, und die einzelnen Regeln noch eins "tiefer" gemanaged werden.)
   * Eventuell auch nicht, wenn für jede Rule eine eigene Nachricht (standard: ausgeblendet) eingebunden wird.
   *      Würde zu ggf. vielen Nachrichten führen
   *      (kleien (!) neben dem attributnamen mit entsrechenden Farben und den Nachrichten als hover Nachricht?
   *      wie sieht das dann im responsive modus aus? draufklicken? )
   * @constructor
   * @param {object} condition - condition, die angibt, wann die Regel verletzt ist.
   * @param {string} ifViolatedType - Typ der Nachricht wenn Regel verletzt (error, warning, information, ...)
   * @param {string} ifViolatedText - Text der Nachricht wenn Regel verletzt
   * @param {object} attributeMessageModul - React Componente zur Anzeige der Nachricht zum Attribut
   */
  constructor(params) {
    const {
      condition = undefined,
      ifViolatedType = 'error',
      ifViolatedText = 'Regel verletzt',
      attributeMessageModul = undefined, // Die React Komponente, auf die zugegriffen werden muss, sobald eine Regel verletzt wird
      attribute = undefined,
    } = params;
    this.condition = condition;
    this.ifViolatedText = ifViolatedText;
    this.ifViolatedType = ifViolatedType;
    this.attributeMessageModul = attributeMessageModul;
    this.attribute = attribute;
    this.DataStore = DataStore; 
    this.messageHandler = this.DataStore.getHandler().messageHandler;
    this.createCondition();
  }

  createCondition() {
    this.condition.attribute = this.attribute;
    this.conditionHandler = new ConditionHandler(
      this.condition,
      this.messageHandler,
    );
  }

  hasError() {
    return this.ifViolatedType === 'error' && this.isViolated();
  }

  /**
   * Funktion, welche die Regeln zu einem Attribut überprüft.
   * @return {boolean} Ob die gespeicherte Regel verletzt ist
   */
  isViolated() {
    const isVio = !this.conditionHandler.evaluate();
    const mString = isVio
      ? `  ==> ( ${this.ifViolatedType}:  ${this.ifViolatedText})`
      : '';
    this.messageHandler.logDebugFormatted(
      'RuleHandler',
      'isViolated',
      '',
      '',
      '',
      [
        `${this.conditionHandler.getString()}=> isViolated: ${isVio.toString()}`,
        mString,
      ],
    );
    return isVio;
  }

  /**
   * Setzt die Nachricht beim Attribut auf die entsprechende Nachricht der Regel, die verletzt wird
   */
  setAttributeMessage() {
    this.attributeMessageModul.show();
  }

  /**
   * Entfernt die Nahricht beim Attribut
   */
  resetAttributeMessage() {
    this.attributeMessageModul.hide();
  }

  /**
   * überprüft die Regel und setzt die AttributNachricht
   */
  checkRule() {
    if (this.isViolated()) {
      this.setAttributeMessage();
    } else {
      this.resetAttributeMessage();
    }
  }
}

export default RuleHandler;
